<template>
  <div>
    <Mainl :activeName="activeTab"></Mainl>
    <div class="page_content">
      <div class="creative_commodity">
        <div class="creative_commodity_title">
          创意商品
        </div>
        <div  class="creative_commodity_select_option">
          <span :class="activeName ===item.Key ? 'creative_commodity_select_active' : ''" @click="changeTabLabel(item.Key)"  v-for="(item,key) in tabLabel" :key="key">{{item.Value}}</span>
        </div>
        <div class="creative_commodity_search_wrap">
          <img class="search_icon" :src="require('@/assets/img/icon_search.png')" />
          <el-input  popper-class="search_popper_class" clearable @clear="initList()" class="search_input" v-model="goodsName" placeholder="请输入内容"></el-input>
          <div class="creative_commodity_search_btn" @click="initList()">搜索</div>
        </div>
        <div v-loading="loading" :element-loading-text="loading_txt">
          <div v-if="list.length>0" class="creative_commodity_list" style=" grid-template-rows: repeat(3,203px);">
            <div  v-for="(v,key) in list" :key="key" class="creative_commodity_list_item">
              <img @click="detail(v.GoodsId)" :src="require('@/assets/img/goods/'+v.CategoryKey+'/'+v.GoodsPics)"/>
              <p>{{v.GoodsName}}</p>
              <el-button class="creative_commodity_list_item_btn"  @click="detail(v.GoodsId)" type="primary">查看详情</el-button>
            </div>
          </div>
          <div v-else class="empty_goods">
            <img :src="require('@/assets/img/shopping_cart_empty.png')"/>
            <p>暂无商品</p>
          </div>
        </div>
        <!-- 不使用分页把当前标签注释掉 -->
        <div class="creative_commodity_list_page">
          <div class="pagination_wrap">
            <el-pagination
              hide-on-single-page
              background
              layout="prev, pager, next"
              :current-page="currentPage"
              :page-size="pageSize"
              :total="total"
              @current-change="handlePageChange">
            </el-pagination>
          </div>

        </div>
      </div>
      <div class="hot_case">
        <div class="hot_case_title">
          热门案例
        </div>
        <div class="hot_case_list">
          <div v-for="(groupItem,key) in groupInfo" :key="key" class="hot_case_item" @click="goDetail(groupItem)">
            <img :src="groupItem.annex_url" />
            <div class="hot_case_item_info">
              <p class="hot_case_item_title">{{groupItem.name}}</p>
              <div class="hot_case_item_type">
                <span>{{groupItem.category_top_name}}</span>
                {{groupItem.category_second_name}}
              </div>
              <div class="hot_case_item_name">
                {{groupItem.company}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script >
/* eslint-disable */
import Mainl from '@/components/Mainl.vue'
import Cookies from "js-cookie";
import * as commfun from "@/common/common.js"

// import index_mixins_page from "@/common/index_mixins_page.js"
export default {
  name: 'Index',
  components: {
    Mainl,
  },
  data: function () {
    return {
      activeTab:"1",
      goodsName:"",//快捷搜索的名称
      activeName:"CPK10000",//默认海报/KV
      tabLabel:[],//列表筛选
      list:[],//列表数据
      total:0,//总条数
      pageSize: 20,             // 每页数量
      currentPage: 1,           // 当前页面
      totalPages: 0,             // 总页数
      goodsType:"CP10001",//一级类目
      categoryKey:'',//二级类目
      //热门案例
      groupInfo: [],
      state1:'',
      loading_txt:'数据加载中',
      loading:false,
      };
  },
  mounted() {
    this.initdict()
    // 加载热门案例数据
    this.initHotList();
  },

  computed: {

  },
  methods: {
    //切换类型
    changeTabLabel(item){
      var selfthis = this
      selfthis.activeName = item
      //清空页码
      selfthis.currentPage = 1
      selfthis.initList();
    },
    //详情界面跳转
    detail(id){
      var url = "detail?id="+id;
      window.open(url);
    },
    initdict:function (){
      var selfthis=this
      var url = "/api/api/goods/dict"
      commfun.ajaxGet(selfthis,url, {},function (selfthis,data){
        console.log(data)
        selfthis.tabLabel = data
        selfthis.initList()
      },function (selfthis,dataError){
        commfun.showMessage(selfthis,'warning',"错误："+dataError.msg)
      })
    },
    initList: function (){
      var selfthis = this
      var url = "/api/api/goods/list"
      var data={
        category_key:this.activeName,
        goods_name:this.goodsName,
        pageSize:this.pageSize,
        currentPage:this.currentPage,
        totalPages:this.totalPages,
      }
      selfthis.loading=true

      commfun.ajaxPost(selfthis,url,data,function (selfthis,data){
        selfthis.loading=false
        selfthis.list  = data.data
        selfthis.total  = data.count
      },function (selfthis,dataError){
        commfun.showMessage(selfthis,'warning',"错误："+dataError.msg)
      })
    },
    // 热门案例数据
    initHotList: function (){
      var selfthis = this
      var url = "/api/api/demand/hotCase"
      commfun.ajaxPost(selfthis,url, {},function (selfthis,data){
        selfthis.groupInfo = data.data
      },function (selfthis,dataError){
        commfun.showMessage(selfthis,'warning',"错误："+dataError.msg)
      })
    },
    handlePageChange(currentPage) {
      // 处理页码变化回调，更新 currentPage 并重新获取数据
      this.currentPage = currentPage;
      this.initList();
    },
    // 案例详情
    goDetail (item) {
      window.open('/casedetail?id=' + item.case_id + '&jump_from=2')
    },
    mlogin: function (type){
      if(type=='example'){
        this.visible = true
      }else{
        this.visible2 = true
      }

    },
    scrollTo: function (type){ //滚动到位置 锚点
      console.log(type)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Goods.vue